import { ReactComponent as RelationshipIcon } from 'assets/stepIcons/relationship_step_icon.svg';
import StepTitle from 'containers/Funnel/StepTitle';
import * as t from 'data';
import { useSelector } from 'hooks';
import React from 'react';

const RelationShipTitle = () => {
  const { concernType } = useSelector(({ proposal }) => proposal);
  return (
    <StepTitle
      icon={<RelationshipIcon />}
      hint={t.funnel.relationship.hint[concernType]}
      title={t.funnel.relationship.title}
    />
  );
};

export default RelationShipTitle;
